import { useState } from 'react';

import Alert from '@mui/material/Alert';
import Button from '@mui/material/Button';

import Snackbar from '@mui/material/Snackbar';

import { captureError, getEnv, useMount } from 'shared/base';

export function NewVersionUpdater() {
  const [newVersionIsAvailable, setNewVersionIsAvailable] = useState(false);

  const checkForNewVersion = async () => {
    try {
      const res = await fetch('/env.js', {
        cache: 'no-store',
      });

      if (!res.ok) {
        throw new Error(`Network error: Failed to fetch env.js (${res.status} ${res.statusText})`);
      }

      const data = await res.text();
      if (!data) {
        throw new Error('No data returned from env.js');
      }

      const match = data.match(/"?NEXT_PUBLIC_CQ_PLATFORM_UI_VERSION"?\s*:\s*"([^"]+)"/);
      const latestVersion = match ? match[1] : null;
      if (
        !latestVersion ||
        latestVersion ===
          getEnv(
            'NEXT_PUBLIC_CQ_PLATFORM_UI_VERSION',
            process.env.NEXT_PUBLIC_CQ_PLATFORM_UI_VERSION,
            'development',
          )
      ) {
        return;
      }
      setNewVersionIsAvailable(true);
    } catch (error) {
      captureError(error, {
        extra: {
          message: 'Error checking for new version',
        },
      });
    }
  };

  useMount(() => {
    checkForNewVersion();

    window.addEventListener('visibilitychange', checkForNewVersion);
    window.addEventListener('focus', checkForNewVersion);

    return () => {
      window.removeEventListener('visibilitychange', checkForNewVersion);
      window.removeEventListener('focus', checkForNewVersion);
    };
  });

  return (
    <Snackbar
      anchorOrigin={{ horizontal: 'center', vertical: 'bottom' }}
      open={newVersionIsAvailable}
    >
      <Alert
        action={
          <Button color="inherit" onClick={() => window.location.reload()} size="small">
            Refresh
          </Button>
        }
        severity="info"
        variant="filled"
      >
        Platform app has been updated. Please
        <br />
        refresh the page to get the latest version.
      </Alert>
    </Snackbar>
  );
}
